<template>
  <v-container text-xs-center>
    <div id="app">
      <v-toolbar text color="white">
        <v-toolbar-title id="components_data_management_vendors_list_title"
          >Vendor's</v-toolbar-title
        >
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          id="components_data_management_vendors_list_search"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <dynamicIcon
          v-model="dialog"
          :icon="'fas fa-plus'"
          :color="'red'"
          id="components_data_management_vendors_list_new_vendor_btn"
          :toolTip="'Add Vendor'"
        />
      </v-toolbar>
      <v-app id="inspire">
        <v-data-table
          :headers="headers"
          :items="vendorsList.edges"
          :search="search"
          :footer-props="rowsPerPageItems"
          id="components_data_management_vendors_list_table_name"
        >
          <template v-slot:top>
            <v-dialog v-model="dialog" max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          cy-data="cy_Vendor_Id"
                          v-model="editedItem.vendorId"
                          label="Vendor Id"
                          :counter="50"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          cy-data="cy_Vendor_Name"
                          v-model="editedItem.vendorName"
                          label="vendorName"
                          :counter="50"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.vendorDesc"
                          label="Vendor Desc"
                          :counter="50"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          cy-data="cy_Vendor_Website"
                          v-model="editedItem.website"
                          label="Website"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          cy-data="cy_Vendor_Address"
                          v-model="editedItem.address"
                          label="Address"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          cy-data="cy_Vendor_City"
                          v-model="editedItem.city"
                          label="City"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          cy-data="cy_Vendor_State"
                          v-model="editedItem.state"
                          label="State"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          cy-data="cy_Vendor_Postal_Code"
                          v-model="editedItem.postalCode"
                          label="Postal Code"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          cy-data="cy_Vendor_Country"
                          v-model="editedItem.country"
                          label="Country"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          cy-data="cy_Vendor_Type"
                          v-model="editedItem.vendorType"
                          label="VendorType"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          cy-data="cy_Vendor_Contact_Person"
                          v-model="editedItem.contactPerson"
                          label="Contact Person"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          cy-data="cy_Vendor_Contact_Number"
                          v-model="editedItem.contactNumber"
                          label="Contact Number"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          cy-data="cy_Vendor_Contact_Email"
                          v-model="editedItem.contactEmail"
                          label="Contact Email"
                          required
                          :rules="emailRules"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.portal"
                          label="Portal"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.portalDetails"
                          label="Portal Details"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-select
                          cy-data="cy_Vendor_Status"
                          v-model="editedItem.status"
                          :items="['active', 'inactive']"
                          label="Status"
                          :rules="requiredRule"
                          required
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.logo"
                          label="Logo"
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="secondary" text @click="close">Cancel</v-btn>
                  <v-btn
                    :disabled="!isFormValid"
                    color="secondary"
                    text
                    @click="save"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item.node)">
              edit
            </v-icon>
            <v-icon small @click="deleteItem(item.node)"> delete </v-icon>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-app>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import dynamicIcon from "../shared/dynamic_icon.vue";

export default {
  components: {
    dynamicIcon
  },
  data() {
    return {
      isFormValid: true,
      search: "",
      dialog: false,
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length <= 50) || "Name must be less than 10 characters"
      ],
      requiredRule: [v => !!v || "Value is required"],
      rowsPerPageItems: {
        "items-per-page-options": [50, 70, 90, -1]
      },
      emailRules: [
        v => !!v || "E-mail is required",
        v =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || // eslint-disable-line
          "E-mail must be valid"
      ],
      headers: [
        { text: "Vendor ID", value: "node.vendorId" },
        {
          text: "Vendor Name",
          align: "left",
          sortable: true,
          value: "node.vendorName"
        },
        { text: "Description", value: "node.vendorDesc" },
        { text: "vendorType", value: "node.vendorType" },
        { text: "Website", value: "node.website" },
        { text: "address", value: "node.address" },
        { text: "city", value: "node.city" },
        { text: "state", value: "node.state" },
        { text: "postalCode", value: "node.postalCode" },
        { text: "country", value: "node.country" },
        { text: "portal", value: "node.portal" },
        { text: "portalDetails", value: "node.portalDetails" },
        { text: "contactPerson", value: "node.contactPerson" },
        { text: "contactEmail", value: "node.contactEmail" },
        { text: "contactNumber", value: "node.contactNumber" },
        { text: "status", value: "node.status" },
        { text: "Logo", value: "node.logo" },
        { text: "updateSource", value: "node.updateSource" },
        { text: "Actions", value: "action", sortable: false }
      ],
      editedIndex: -1,
      editedItem: {
        "node.vendorId": "",
        "node.vendorName": 0,
        "node.vendorDesc": 0,
        "node.vendorType": 0,
        "node.website": 0,
        "node.address": 0,
        "node.city": 0,
        "node.state": 0,
        "node.postalCode": 0,
        "node.country": 0,
        "node.portal": 0,
        "node.portalDetails": 0,
        "node.contactPerson": 0,
        "node.contactNumber": 0,
        "node.contactEmail": 0,
        "node.status": 0,
        "node.logo": "",
        "node.updateSource": 0
      },
      defaultItem: {
        "node.vendorId": "",
        "node.vendorName": 0,
        "node.vendorDesc": 0,
        "node.vendorType": 0,
        "node.website": 0,
        "node.address": 0,
        "node.city": 0,
        "node.state": 0,
        "node.postalCode": 0,
        "node.country": 0,
        "node.portal": 0,
        "node.portalDetails": 0,
        "node.contactPerson": 0,
        "node.contactNumber": 0,
        "node.contactEmail": 0,
        "node.status": 0,
        "node.logo": "",
        "node.updateSource": 0
      }
    };
  },
  created() {
    this.handleGetVendorsList();
  },
  computed: {
    ...mapGetters(["loading", "vendorsList"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  methods: {
    handleGetVendorsList() {
      // reach out of Vuex store, fire action that gets posts for carousel
      this.$store.dispatch("allVendors");
    },
    handleVendorMerge() {
      //if (this.$refs.form.validate()) {
      if (this.editedItem.vendorId) {
        this.$store.dispatch("vendorMerge", {
          vendorSeqno: this.editedItem.vendorSeqno || 0,
          vendorId: this.editedItem.vendorId,
          vendorName: this.editedItem.vendorName,
          vendorDesc: this.editedItem.vendorDesc,
          vendorType: this.editedItem.vendorType,
          website: this.editedItem.website,
          address: this.editedItem.address,
          city: this.editedItem.city,
          state: this.editedItem.state,
          postalCode: this.editedItem.postalCode,
          country: this.editedItem.country,
          portal: this.editedItem.portal,
          portalDetails: this.editedItem.portalDetails,
          contactPerson: this.editedItem.contactPerson,
          contactNumber: this.editedItem.contactNumber,
          contactEmail: this.editedItem.contactEmail,
          status: this.editedItem.status == "active" ? 1 : 0,
          logo: this.editedItem.logo,
          updateSource: "VueAPP Marketplace"
        });
      }
    },
    handleVendorDelete() {
      // if (this.$ref.dialog.validate()) {
      // check for any rules validations on the form

      this.$store.dispatch("vendorDelete", {
        vendorSeqno: this.editedItem.vendorSeqno
      });
      //}
    },

    editItem(item) {
      this.editedIndex = this.handleGetVendorsList.toString().indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.handleGetVendorsList.toString().indexOf(item);
      this.editedItem = Object.assign({}, item);
      confirm("Are you sure you want to delete this item?") &&
        this.handleVendorDelete(index);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      this.handleVendorMerge();
      this.close();
    }
  }
};
</script>
